<template>
  <div class="about-page">
    <BaseImg :title="$t('about.Title')" bgName="bg_about.png" />
    <PublicBreadcrumb />
    <BaseAbout :isBgBlue="false" />
    <section class="about-details">
      <div class="about-details-inner">
        <div class="detail-card">
          <p class="eyebrow">{{ $t('about.VerificationLabel') }}</p>
          <h2>{{ $t('about.VerificationTitle') }}</h2>
          <p>{{ $t('about.VerificationIntro') }}</p>
          <p class="list-lead">{{ $t('about.VerificationAsk') }}</p>
          <ul class="check-list two-columns">
            <li v-for="document in documents" :key="document">{{ $t(document) }}</li>
          </ul>
          <p class="list-lead">{{ $t('about.PurposeLead') }}</p>
          <ol class="purpose-flow">
            <li v-for="purpose in purposes" :key="purpose">{{ $t(purpose) }}</li>
          </ol>
          <p>{{ $t('about.VerificationPurpose') }}</p>
          <p class="pull-quote">{{ $t('about.VerificationQuote') }}</p>
          <router-link :to="$siteLink('/kyc-source-of-funds')" class="text-link">{{ $t('about.KycLink') }} <span aria-hidden="true">→</span></router-link>
        </div>
        <div class="detail-card">
          <p class="eyebrow">{{ $t('about.PaymentLabel') }}</p>
          <h2>{{ $t('about.PaymentTitle') }}</h2>
          <p>{{ $t('about.PaymentIntro') }}</p>
          <p>{{ $t('about.PaymentControls') }}</p>
          <p class="list-lead">{{ $t('about.PaymentAdvice') }}</p>
          <ul class="check-list">
            <li v-for="payment in payments" :key="payment">{{ $t(payment) }}</li>
          </ul>
          <router-link :to="$siteLink('/security')" class="text-link">{{ $t('about.SafetyLink') }} <span aria-hidden="true">→</span></router-link>
        </div>
      </div>
    </section>
    <section class="about-values" aria-labelledby="about-values">
      <div class="about-values-inner">
        <h2 id="about-values">{{ $t('about.ValuesTitle') }}</h2>
        <p class="values-intro">{{ $t('about.ValuesIntro') }}</p>
        <dl class="values-list">
          <div v-for="value in values" :key="value.title">
            <dt>{{ $t(value.title) }}</dt>
            <dd>{{ $t(value.text) }}</dd>
          </div>
        </dl>
      </div>
    </section>
    <section class="about-closing">
      <div class="about-closing-inner">
        <h2>{{ $t('about.ClosingTitle') }}</h2>
        <p>{{ $t('about.ClosingText') }}</p>
        <p class="closing-tagline">{{ $t('about.Heading') }}</p>
      </div>
    </section>
    <BaseSupporters />
  </div>
</template>

<script>
import BaseImg from '@/components/BaseImg.vue'
import PublicBreadcrumb from '@/components/PublicBreadcrumb.vue'
import BaseAbout from '@/components/BaseAbout.vue'
import BaseSupporters from '@/components/BaseSupporters.vue'

export default {
  components: { PublicBreadcrumb, BaseImg, BaseAbout, BaseSupporters },
  data () {
    return {
      documents: Array.from({ length: 6 }, (_, index) => 'about.Document' + (index + 1)),
      payments: Array.from({ length: 5 }, (_, index) => 'about.Payment' + (index + 1)),
      purposes: Array.from({ length: 5 }, (_, index) => 'about.Purpose' + (index + 1)),
      values: Array.from({ length: 6 }, (_, index) => ({ title: 'about.Value' + (index + 1) + 'Title', text: 'about.Value' + (index + 1) + 'Text' }))
    }
  }
}
</script>

<style scoped>
.about-page ::v-deep .public-breadcrumb { max-width: 1440px; padding-right: clamp(24px, 7vw, 100px); padding-left: clamp(24px, 7vw, 100px); }
.about-details { background: #f5f5f5; color: #163257; }
.about-details-inner { max-width: 1440px; margin: 0 auto; padding: clamp(36px, 6vw, 88px) clamp(24px, 7vw, 100px); display: grid; grid-template-columns: 1fr 1fr; gap: clamp(24px, 3vw, 40px); align-items: start; }
.detail-card { padding: clamp(24px, 3vw, 44px); background: #fff; border-top: 3px solid #bc9a41; border-radius: 4px; }
.eyebrow { color: #8a6e29; font-size: 16px; font-weight: 600; margin: 0; }
h2 { color: #163257; font-size: clamp(24px, 2.4vw, 32px); font-weight: 600; line-height: 1.35; margin: 10px 0 20px; }
p, li { font-size: 16px; line-height: 1.8; }
p { margin: 0 0 16px; }
.list-lead { margin: 24px 0 10px; font-weight: 600; }
.check-list { list-style: none; padding: 0; margin: 0 0 8px; }
.check-list li { position: relative; padding: 8px 0 8px 22px; border-bottom: 1px solid #e6ebf0; }
.check-list li::before { content: ""; position: absolute; left: 2px; top: 1.15em; width: 8px; height: 8px; border-radius: 50%; background: #bc9a41; }
.check-list.two-columns { display: grid; grid-template-columns: 1fr 1fr; column-gap: 28px; }
.purpose-flow { list-style: none; counter-reset: purpose; display: flex; flex-wrap: wrap; gap: 10px; padding: 0; margin: 0 0 22px; }
.purpose-flow li { counter-increment: purpose; display: inline-flex; align-items: center; gap: 8px; padding: 7px 14px; background: #f1f4f8; border-radius: 100px; font-size: 15px; line-height: 1.5; }
.purpose-flow li::before { content: counter(purpose); display: inline-flex; align-items: center; justify-content: center; flex: none; width: 22px; height: 22px; border-radius: 50%; background: #163257; color: #fff; font-size: 13px; }
.pull-quote { margin: 20px 0; padding: 4px 0 4px 18px; border-left: 3px solid #bc9a41; font-size: 18px; font-weight: 600; line-height: 1.7; }
.text-link { display: inline-flex; align-items: center; min-height: 44px; color: #163257; text-decoration: underline; text-underline-offset: 5px; font-weight: 600; line-height: 1.7; }
.text-link span { margin-left: 8px; }
.about-values { color: #163257; background: #fff; }
.about-values-inner { max-width: 1440px; margin: 0 auto; padding: clamp(40px, 6vw, 88px) clamp(24px, 7vw, 100px); }
.values-intro { max-width: 40em; font-size: 17px; }
.values-list { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 20px; margin: 28px 0 0; }
.values-list > div { padding: 22px 24px; border: 1px solid #d8dfe7; border-radius: 4px; }
.values-list dt { color: #8a6e29; font-size: 20px; font-weight: 600; margin-bottom: 6px; }
.values-list dd { margin: 0; font-size: 16px; line-height: 1.75; }
.about-closing { background: #163257; color: #fff; text-align: center; }
.about-closing-inner { max-width: 860px; margin: 0 auto; padding: clamp(40px, 6vw, 80px) 24px; }
.about-closing h2 { color: #fff; margin-top: 0; font-size: clamp(26px, 3vw, 38px); }
.about-closing p { font-size: 17px; }
.about-closing .closing-tagline { margin: 24px 0 0; color: #e4c37c; font-weight: 600; letter-spacing: .08em; }
@media (max-width: 960px) {
  .about-details-inner { grid-template-columns: 1fr; }
  .values-list { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}
@media (max-width: 540px) {
  .check-list.two-columns, .values-list { grid-template-columns: 1fr; }
  .pull-quote { font-size: 17px; }
}
</style>
